import API from '@/services';
import { next } from '../next';

type HandleRequestCB = (res: any) => void;

const handleClickExpediteDelivery = async (params: any, nextParams: any, cb?: HandleRequestCB) => {
  (API as { postExpediteDelivery: Function })
    .postExpediteDelivery(params)
    .then((res: any) => {
      next(nextParams);
      cb?.(res);
    })
    .catch((err: any) => {
      cb?.(err);
    });
};

export default handleClickExpediteDelivery;
